import { Link, useNavigate } from 'react-router-dom';

export function Logo() {
  const navigate = useNavigate();
  return (
    <a
      href="/dashboard"
      onClick={(e) => {
        e.preventDefault();
        navigate('/dashboard');
      }}
    >
      <svg width="176.8" height="25.6" viewBox="0 0 221 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_401_26963)">
          <path d="M0 16C0 6.44767 7.33359 0 16.8002 0C25.152 0 29.2377 4.72786 31.0936 8.99839L23.019 12.7536C22.2328 10.3446 19.8161 8.25765 16.8002 8.25765C12.5341 8.25765 9.5182 11.6908 9.5182 16C9.5182 20.3092 12.5341 23.7424 16.8002 23.7424C19.8161 23.7424 22.2263 21.6554 23.019 19.2464L31.0936 22.9565C29.2828 27.0853 25.152 32 16.8002 32C7.33359 32 0 25.5072 0 16Z" fill="white"/>
          <path d="M74.1929 0.50885H83.5694V23.2786H95.3108V31.4396H74.1994V0.50885H74.1929Z" fill="white"/>
          <path d="M105.312 8.67632H97.0057V0.50885H122.944V8.66988H114.682V31.4396H105.306V8.67632H105.312Z" fill="white"/>
          <path d="M127.313 0.50885H136.825V18.409C136.825 21.3784 138.359 23.7423 142.206 23.7423C146.053 23.7423 147.542 21.3784 147.542 18.409V0.50885H157.053V18.6924C157.053 26.3897 152.646 32.0064 142.206 32.0064C131.766 32.0064 127.313 26.3961 127.313 18.744V0.50885Z" fill="white"/>
          <path d="M176.502 21.5201H173.113V31.446H163.736V0.50885H180.253C187.49 0.50885 191.389 5.33333 191.389 11.1304C191.389 16.4638 188.282 19.2915 185.821 20.496L191.434 31.4396H180.762L176.496 21.5137L176.502 21.5201ZM178.822 8.30273H173.113V13.7262H178.822C180.401 13.7262 181.883 12.7085 181.883 10.9887C181.883 9.26891 180.401 8.29629 178.822 8.29629V8.30273Z" fill="white"/>
          <path d="M197.517 0.50885H221V8.30273H206.893V11.9227H220.678V19.7166H206.893V23.6586H221V31.4525H197.517V0.50885Z" fill="white"/>
          <path d="M51.5993 0C42.0425 0 34.6638 6.49275 34.6638 16C34.6638 25.5072 42.0425 32 51.5993 32C61.1562 32 68.5349 25.5072 68.5349 16C68.5349 6.49275 61.1562 0 51.5993 0Z" fill="#BA0000"/>
        </g>
        <defs>
          <clipPath id="clip0_401_26963">
            <rect width="221" height="32" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </a>
  );
}
